import ninjaApi from 'store/redux/apis/ninja.api';

export const salesApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['Sales', 'DefaultWorkspace'],
  endpoints: (build) => ({
    getCollectEventTypes: build.query({
      query: (body) => ({
        url: '/sales/collect/events',
        method: 'POST',
        body,
      }),
      providesTags: ['CollecEvents'],
    }),
    conversionSend: build.mutation({
      query: (body) => ({
        url: '/network/conversions/send-offline-conversion',
        method: 'POST',
        body,
      }),
      providesTags: ['Sales'],
    }),
    sendEventConversion: build.mutation({
      query: (body) => ({
        url: '/network/conversions/send-event-conversion',
        method: 'POST',
        body,
      }),
      providesTags: ['Sales'],
    }),

    crmSalesList: build.query({
      query: (body) => ({
        url: '/acquisition/crm',
        method: 'POST',
        body,
      }),
      providesTags: ['Sales'],
    }),

    postbacksSalesList: build.query({
      query: (body) => ({
        url: '/acquisition/postbacks',
        method: 'POST',
        body,
      }),
      providesTags: ['Sales'],
    }),

    eventsSalesList: build.query({
      query: (body) => ({
        url: '/acquisition/events',
        method: 'POST',
        body,
      }),
      providesTags: ['Sales'],
    }),
  }),
});

export const {
  useGetCollectEventTypesQuery,
  useSendEventConversionMutation,
  useConversionSendMutation,
  useGetCrmSalesListQuery,
  useGetPostbacksSalesListQuery,
  useGetEventsSalesListQuery,
} = salesApi;
